import React from 'react'
import {Link} from "react-router-dom";
import SingleGameItem from "./single-game-item";
import {Swiper, SwiperSlide} from "swiper/react";
import './index.css'
import {LazyLoadImage} from "react-lazy-load-image-component";
import 'swiper/css';

const TournamentGames = props => {

    const {games = []} = props

    return (
        games?.length === 1 ? <div style={{
                minHeight: 280
            }}>
                <SingleGameItem game={games[0]}/>
            </div> :
            <div className="mySwiper_game" style={{
                minHeight: 280
            }}>
                {games?.map((game) => (
                    <Link to={`/casino/games/${game?.slug}`} className="game-link">
                        <LazyLoadImage
                            effect="blur"
                            threshold="100"
                            className="row-game-img"
                            placeholderSrc={game?.image}
                            src={game?.image} alt=""/>

                    </Link>
                ))}
            </div>
    )

}

export default React.memo(TournamentGames)
